import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from '../services/ajax.service';

@Component({
  selector: 'app-essentials',
  templateUrl: './essentials.component.html',
  styleUrls: ['./essentials.component.scss']
})
export class EssentialsComponent implements OnInit {

  resources: any[] = []
  constructor(private _ajaxService: AjaxService, private _router: Router) { }

  ngOnInit(): void {
    this.getResources();
  }

  getResources() {
    const request = {
      parentId : 2
    } 
    this._ajaxService.post('dashboard/getResourcesOnParentId', request).then((response: any) => {
      if (response.statusCode == 200) {
        this.resources = response.data;
      }
    });
  }

  handleRedirect(path : string) {
    if (path != '' && path != null && path != undefined) {
      if (path.startsWith('/') || !path.startsWith('http')) {
        this._router.navigate([path])
      } else {
        window.open(path, "_blank");
      }
    }
  }
}
